import {
  availabilityOptions,
  englishLevelOptions,
  sourceOptions,
  yearsOfExperienceOptions,
  countriesOptions,
  developerTypeOptions,
  yesOrNoBooleanOptions,
} from '@/utils/dropdownOptions';

export const textInputs = [
  'id',
  'firstName',
  'lastName',
  'email',
  'mobilePhone',
  'githubUrl',
  'linkedinUrl',
  'referredBy',
  'salaryExpectation',
  'city',
];

export const radioInputs = ['overallRating'];

export const dropDownInputs = [
  'country',
  'developerType',
  'skills',
  'status',
  'source',
  'experience',
  'englishLevel',
  'availability',
  'isTalentPool',
  'candidateOwner',
  'hasFintechExperience',
];

export const allSelectedFields = [...textInputs, ...radioInputs, ...dropDownInputs];

export const dropdownOptionsMap = {
  country: countriesOptions,
  developerType: developerTypeOptions,
  englishLevel: englishLevelOptions,
  source: sourceOptions,
  experience: yearsOfExperienceOptions,
  availability: availabilityOptions,
  isTalentPool: yesOrNoBooleanOptions,
  candidateOwner: [],
  pictureUrl: yesOrNoBooleanOptions,
  hasFintechExperience: yesOrNoBooleanOptions,
};

export const fieldsAndFriendlyLabels = {
  id: 'Candidate ID',
  firstName: 'First Name',
  lastName: 'Last Name',
  name: 'Name',
  overallRating: 'Overall Rating',
  email: 'E-mail',
  mobilePhone: 'Mobile',
  skills: 'Main Tech Stack',
  mainTechStack: 'Main Tech Stack',
  country: 'Country',
  developerType: 'Developer Type',
  status: 'Candidate Status',
  source: 'Source',
  experience: 'Years of Experience',
  englishLevel: 'English Level',
  githubUrl: 'Github',
  linkedinUrl: 'Linkedin',
  trioProfileUrl: 'Trio Profile',
  availability: 'Availability',
  ownerId: 'Candidate Owner',
  candidateOwner: 'Candidate Owner',
  salaryExpectation: 'Salary Expectations',
  isTalentPool: 'Talent Pool',
  referredBy: 'Referred By',
  city: 'City',
  createdAt: 'Created At',
  updatedAt: 'Updated At',
  hasFintechExperience: 'Has Fintech Experience',
};

export const fieldsAndFriendlyLabelsForFilters = {
  ...fieldsAndFriendlyLabels,
  status: 'Status',
  firstName: 'Name',
  createdAt: 'Created Time',
  updatedAt: 'Modifed Time',
  pictureUrl: 'Has Profile Picture',
  hasFintechExperience: 'Has Fintech Experience',
};

export const fieldsAndFriendlyLabelsForFiltersList = Object.entries(
  fieldsAndFriendlyLabelsForFilters
);
export const fieldsAndFriendlyLabelsList = Object.entries(fieldsAndFriendlyLabels);

export const sortByGroupOptions = [
  'firstName',
  'lastName',
  'skills',
  'status',
  'trioProfileUrl',
  'country',
  'developerType',
  'candidateOwner',
  'pictureUrl',
  'hasFintechExperience',
];

export const sortedGroups = [
  [
    // 'id',
    'firstName',
    'mobilePhone',
    'lastName',
    'country',
    'email',
    // 'overallRating',
    'city',
  ],
  ['developerType', 'experience', 'skills', 'englishLevel', 'hasFintechExperience'],
  [
    'status',
    'availability',
    'candidateOwner',
    'salaryExpectation',
    'source',
    'isTalentPool',
    'referredBy',
  ],
  ['githubUrl', 'linkedinUrl', 'trioProfileUrl'],
];
